import { render } from "./MatchesDropdown.vue?vue&type=template&id=65467b64&scoped=true"
import script from "./MatchesDropdown.vue?vue&type=script&lang=js"
export * from "./MatchesDropdown.vue?vue&type=script&lang=js"

import "./MatchesDropdown.vue?vue&type=style&index=0&id=65467b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65467b64"]])

export default __exports__